exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SizingSelect__selectBox___ZboV9 {\n    width: 100%;\n}\n\n.SizingSelect__selectSurround___XOG78 {\n    display: block;\n}\n", ""]);

// exports
exports.locals = {
	"selectBox": "SizingSelect__selectBox___ZboV9",
	"selectSurround": "SizingSelect__selectSurround___XOG78"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/SizingSelect.icss
// module id = 1350
// module chunks = 0